import { Controller } from "@hotwired/stimulus";

import { default as CodeMirror, CodeMirrorOptions } from "./codemirror";

const CODEMIRROR_CONFIG: CodeMirrorOptions = {
  mode: "application/json",
  tabSize: 2,
  indentUnit: 2,
  indentWithTabs: false,
  autoCloseBrackets: true,
  matchBrackets: true,
  showCursorWhenSelecting: true,
};

// Connects with data-controller="rules"
export default class extends Controller {
  static targets = ["editor", "ruleSelect", "section"];
  declare editorTarget: HTMLInputElement;
  declare ruleSelectTarget: HTMLInputElement;
  declare sectionTarget: HTMLInputElement;

  editor: CodeMirror;

  connect() {
    this.editor = CodeMirror.fromTextArea(this.editorTarget, CODEMIRROR_CONFIG);

    this.editor.getWrapperElement().setAttribute("name", "codeMirrorEditor");

    this.ruleSelectTarget.addEventListener("change", (event) => {
      this.updateRuleName(event.target);
    });
  }

  updateRuleName(select) {
    const ruleName = select.value;
    const exampleBody = this.getExampleBodyForRule(ruleName);
    if (this.sectionTarget.classList.contains("hidden")) {
      this.sectionTarget.classList.remove("hidden");
    }

    this.editor.setValue(
      JSON.stringify({ rule: ruleName, value: exampleBody }, null, 2),
    );
  }

  getExampleBodyForRule(ruleName) {
    switch (ruleName) {
      case "pipeline.trigger_build.pipeline":
        return {
          source_pipeline_uuid: "pipeline-uuid",
          target_pipeline_uuid: "pipeline-uuid",
        };
      case "pipeline.artifacts_read.pipeline":
        return {
          source_pipeline_uuid: "pipeline-uuid",
          target_pipeline_uuid: "pipeline-uuid",
        };
      default:
        return {};
    }
  }
}
